import React from 'react';
import AuthFormFooter from '../../Common/AuthCommon/AuthFormFooter';

const JobDetailsComponent = ({ job }) => {
    return (
        <div className='job-landing-page__job-info-main'>
          <div className='job-page-card px-32'>
              <h3 className='job-page-card__title'>{job.job_title}</h3>
              <div className='job-page-card__description' dangerouslySetInnerHTML={{ __html: job.job_description }}></div>
          </div>
          <div className='job-page-footer'>
            <AuthFormFooter />
          </div>
        </div>
    )
}

export default JobDetailsComponent;